const newsDetailData = {
    category: "मध्य प्रदेश",
    title: "दिल्ली दौरे पर सीएम मोहन यादव, किसान जन आंदोलन यात्रा निकालेंगे जीतू",
    description: "सीएम मोहन यादव आज जयपुर में निवेश से जुड़े मुद्दों पर चर्चा करेंगे। इसके बाद वे दिल्ली जाएंगे।",
    image: "https://i.ytimg.com/vi/lXu-E9hXeFg/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLAsTbcLLjU5k-BQ5L0PwXFECm00MA",
    author: {
        name: "Kaushiki",
        avatar: "https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_640.png",
        date: "05 Jan 2026 09:21 IST"
    },
    whatsappText: "ताजा खबरों से अपडेट रहने के लिए हमारे Whatsapp Channel को Join करें",

    content: [{
            heading: "सीएम का व्यस्त दिन",
            paragraph: "भोपाल। मध्यप्रदेश के मुख्यमंत्री डॉ. मोहन यादव का आज (05 जनवरी) का दिन बहुत ही व्यस्त रहने वाला है। सीएम आज जयपुर और दिल्ली के दौरे पर रहेंगे। वे जयपुर में ग्लोबल समिट के जरिए निवेश और स्टार्टअप्स को प्रोत्साहित करेंगे।"
        },
        {
            heading: "दिल्ली में मुलाकात",
            paragraph: "इसके बाद सीएम दिल्ली रवाना होंगे, जहां वे केंद्रीय मंत्री नितिन गडकरी से मुलाकात करेंगे। इस दौरान मध्य प्रदेश की सड़क परियोजनाओं और अधोसंरचना विकास पर चर्चा होगी।"
        },
        {
            heading: "किसान जन आंदोलन यात्रा",
            paragraph: "राजनीतिक जानकारों के अनुसार किसान जन आंदोलन यात्रा को लेकर भी रणनीति बनाई जाएगी।"
        },
        {
            heading: "निवेश और योजनाएं",
            paragraph: "सीएम जयपुर में निवेश से जुड़े मुद्दों पर चर्चा करेंगे। इसके बाद वे दिल्ली जाएंगे, जहां केंद्रीय मंत्री नितिन गडकरी के साथ सड़क परियोजनाओं को लेकर बातचीत होगी।"
        },
        {
            heading: "चुनाव और रणनीति",
            paragraph: "मध्य प्रदेश में आगामी चुनाव को ध्यान में रखते हुए कई रणनीतियां बनाई जा रही हैं। किसान जन आंदोलन यात्रा को लेकर पार्टी स्तर पर मंथन जारी है।"
        },
        {
            heading: "प्रोजेक्ट्स की समीक्षा",
            paragraph: "इस दौरे के दौरान सीएम विभिन्न प्रोजेक्ट्स की समीक्षा करेंगे और निवेशकों के साथ मीटिंग करेंगे।"
        },
        {
            heading: "सोशल मीडिया अपडेट",
            paragraph: "जनता तक सीएम की योजनाओं और कार्यक्रमों की जानकारी पहुँचाने के लिए सोशल मीडिया का भी इस्तेमाल किया जाएगा।"
        }
    ]
};

export default newsDetailData;